import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Header from '../Header';
import Scrollable from '../Scrollable';
import useAuth from '../../hooks/useAuth';
import LogService from '../../services/LogService';

export default function Layout({ children }) {
  const { user } = useAuth();
  const { pathname, hash } = useLocation();

  // Scroll to top when page change
  useEffect(() => {
    const scrollable = document.querySelector('main');

    if (scrollable) {
      scrollable.scrollTo(0, 0);
    }
  }, [pathname]);

  // Registrar log de acesso
  useEffect(() => {
    const { id_usuario, id_entidade, id_matricula } = user;
    LogService.logAcesso(id_usuario, id_entidade, id_matricula);
  }, [user, pathname, hash]);

  return (
    <>
      {/* Header */}
      <Header />
      {/* Main */}
      <Scrollable component="main" id="main">
        {/* Content */}
        {children}
      </Scrollable>
    </>
  );
}
